/*
 * Views for the List region of the substitutions page
 */

define([
  "jquery",
  "marionette",
  "underscore",
  "modules/reportSplit/reports/reportArea/template/reportAreaTemplate.html",
  "highcharts/highcharts",
], function ($, Marionette, _, ReportAreaTemplate, Highcharts) {
  "use strict";

  const ReportAreaView = {};

  ReportAreaView.reportsLayout = Marionette.Layout.extend({
    template: ReportAreaTemplate,
    className: "max-height", //set the div container of this layout to the height of its parent
    regions: {
      chart: "#chart",
      configEntries: "#configDiv",
      southChart: "#southChart",
      eastChart: "#chartEast",
      westChart: "#chartWest",
      southEastChart: "#southEastChart",
      southWestChart: "#southWestChart",
      //reportDisplay
    },
    getHighcharts: function (area) {
      // NOTE: Cannot use the ui functionality built-in to MarionetteJS because it is
      // evaluated too soon.
      let chartId;
      if (area === "west") {
        chartId = this.$el.find("#chartWest > div").data("highcharts-chart");
      } else if (area === "center") {
        chartId = this.$el.find("#chart > div").data("highcharts-chart");
      } else if (area === "east") {
        chartId = this.$el.find("#chartEast > div").data("highcharts-chart");
      } else if (area === "southwest") {
        chartId = this.$el.find("#southWestChart > div").data("highcharts-chart");
      } else if (area === "south") {
        chartId = this.$el.find("#southChart > div").data("highcharts-chart");
      } else if (area === "southeast") {
        chartId = this.$el.find("#southEastChart > div").data("highcharts-chart");
      }
      if (!_.isUndefined(chartId) && !_.isNull(chartId)) {
        return Highcharts.charts[+chartId];
      }
    },
    hideReportArea: function (displayHint) {
      if (displayHint) {
        if (displayHint === "central") {
          this.$el.find("#southChart").addClass("nodisplay");
        }
        if (displayHint === "east") {
          //make east invisible
          this.$el.find("#chartEast").addClass("nodisplay");
          //expand central
          this.$el.find("#chart").removeClass("span6");
          this.$el.find("#chart").addClass("span12");
          $(window).trigger("resize");
        }
        if (displayHint === "west") {
          //make west invisible
          this.$el.find("#chartWest").addClass("nodisplay");
          //expand central and east
          this.$el.find("#chart").removeClass("span4");
          this.$el.find("#chart").addClass("span6");
          this.$el.find("#chartEast").removeClass("span4");
          this.$el.find("#chartEast").addClass("span6");
          //refresh
          $(window).trigger("resize");
        }
        if (displayHint === "south") {
          this.$el.find("#southChart").addClass("nodisplay");
        }
      }
    },
    /**
     * Figure out where to display the report.
     * The report will have a property of displayHint that tells us where to display it.
     * If there is none, we assume it should be in the center area.
     * Eventually, we may have dashboards change the display hints on reports before sending them
     * to the show() method, so that the dashboard can override the defaults.
     * For now, this value is part of the report object we receive from the web server, and we'll
     * always display the report in the same area.
     *
     * We use jQuery to remove the 'style' attribute (which defaults to display:none), and if more
     * than one chart will be visible in a row, change the Twitter Bootstrap span lengths so that
     * more charts will fit in the row.  Currently, up to 3 in a row are supported.
     */
    showReportArea: function (displayHint) {
      //I'm not 100% thrilled with how this is kind of hard-coded,
      //but it's functional as-is.
      let renderTo = "#chart";
      if (displayHint === "central") {
        renderTo = "#chart";
        if (this.$el.find(renderTo).hasClass("nodisplay")) {
          this.$el.find(renderTo).removeClass("nodisplay");
        }
      }
      if (displayHint === "east") {
        renderTo = "#chartEast";
        if (this.$el.find(renderTo).hasClass("nodisplay")) {
          //make east visible
          this.$el.find("#chartEast").removeClass("nodisplay");
          //shrink central
          //if it has span6 and west IS visible
          if (
            this.$el.find("#chart").hasClass("span6") &&
            this.$el.find("#chartWest").attr("style") === undefined
          ) {
            this.$el.find("#chart").removeClass("span6");
            this.$el.find("#chart").addClass("span4");
            this.$el.find("#chartWest").removeClass("span6");
            this.$el.find("#chartWest").addClass("span4");
          } else if (this.$el.find("#chart").hasClass("span12")) {
            this.$el.find("#chart").removeClass("span12");
            this.$el.find("#chart").addClass("span6");
            //east will be smaller when it displays, too
            this.$el.find("#chartWest").removeClass("span6");
            this.$el.find("#chartWest").addClass("span4");
          }
          $(window).trigger("resize");
        }
      }
      if (displayHint === "west") {
        renderTo = "#chartWest";
        if (this.$el.find(renderTo).hasClass("nodisplay")) {
          //shrink central and east
          if (this.$el.find("#chart").hasClass("span6")) {
            this.$el.find("#chart").removeClass("span6");
            this.$el.find("#chart").addClass("span4");
            this.$el.find("#chartEast").removeClass("span6");
            this.$el.find("#chartEast").addClass("span4");
          } else if (this.$el.find("#chart").hasClass("span12")) {
            this.$el.find("#chart").removeClass("span12");
            this.$el.find("#chart").addClass("span6");
            //east will be smaller when it displays, too
            this.$el.find("#chartEast").removeClass("span6");
            this.$el.find("#chartEast").addClass("span4");
          }
          //move the western span
          this.$el.find("#chartWest").prependTo("#reportRow");
          //make west visible
          this.$el.find("#chartWest").removeClass("nodisplay");
          //refresh
          $(window).trigger("resize");
        }
      }
      if (displayHint === "south") {
        renderTo = "#southChart";

        if (this.$el.find(renderTo).hasClass("nodisplay")) {
          this.$el.find("#southChart").removeClass("nodisplay");
        }
      }
      if (displayHint === "southEast") {
        renderTo = "#southEastChart";
        if (this.$el.find(renderTo).hasClass("nodisplay")) {
          //make east visible
          this.$el.find("#southEastChart").removeClass("nodisplay");
          //shrink central
          this.$el.find("#southChart").removeClass("span10");
          this.$el.find("#southChart").addClass("span6");
          $(window).trigger("resize");
        }
      }
      if (displayHint === "southWest") {
        renderTo = "#southWestChart";
        if (this.$el.find(renderTo).hasClass("nodisplay")) {
          //shrink central and east
          this.$el.find("#southChart").removeClass("span6");
          this.$el.find("#southChart").addClass("span4");
          this.$el.find("#southEastChart").removeClass("span6");
          this.$el.find("#southEastChart").addClass("span4");
          //refresh
          $(window).trigger("resize");
          //move the western span
          this.$el.find("#southWestChart").prependTo("#lowerReportRow");
          //make west visible
          this.$el.find("#southWestChart").removeClass("nodisplay");
        }
      }
    },
  });

  return ReportAreaView;
});
